import React from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import TopBar from './TopBar/TopBar';
import HeaderBar from './HeaderBar/HeaderBar';
import SiderBar from './SiderBar/SiderBar';
import FooterBar from './FooterBar/FooterBar';
import { getScrollTop } from '../../utils/utils';

const { Content } = Layout;

class MainLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuList: [],
      headerMenuList: [],
      isHeaderFixed: false,
    };
  }

  componentDidMount() {
    this.handleScrollChange();
  }

  handleScrollChange = () => {
    window.onscroll = (e) => {
      const top = getScrollTop();
      if (top < 31) {
        this.setState({
          siderTop: this.state.siderTopBase - top,
          isHeaderFixed: false,
        });
      } else if (!this.state.isHeaderFixed) {
        this.setState({
          isHeaderFixed: true,
          siderTop: 64,
        });
      }
    };
  }

  render() {
    return (
      <div className="bill99">
        <Layout>
          <HeaderBar
            history={this.props.history}
            menuList={this.state.headerMenuList}
            onClick={(key) => this.handleHeaderClick(key)}
            isHeaderFixed={this.state.isHeaderFixed}
          />
          {/* <div style={{ height: '64px' }}></div> */}
          <Content>
            <Layout style={{ margin: '24px 75px', backgroundColor: '#fff', minHeight: `${window.screen.availHeight - 300}` }}>
              {this.props.children}
            </Layout>
          </Content>
          <FooterBar />
        </Layout>
      </div>
    );
  }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/views/MainLayout/VisitorMainLayout.jsx